import {
  Component,
  ViewChild,
  AfterViewInit,
  EventEmitter,
  Input,
  Output,
  AfterViewChecked,
  ChangeDetectorRef,
} from '@angular/core';

import { DxFormComponent } from 'devextreme-angular';
import { isNotUndefined } from '../../../core/util/functions';

@Component({
  selector: 'kt-dxform',
  templateUrl: './frm.component.html',
  styleUrls: ['./frm.component.scss'],
})
export class FrmComponent implements AfterViewInit, AfterViewChecked {
  @ViewChild(DxFormComponent, { static: false }) myform: DxFormComponent;

  @ViewChild('frm', { static: false }) frm: DxFormComponent;

  @Input() dataForm: any = {};

  @Input() rows: string = '2';

  @Input() idForm: string = 'form';

  @Input() fields: any[] = [];

  @Input() formTitle: string = '';
  @Input() extras: any;
  @Output() formEmit: EventEmitter<any> = new EventEmitter();

  @Output() customValidationCheck: EventEmitter<any> = new EventEmitter();

  contentCheked: boolean = false;
  /* rules: Object;
	positions: string[] = [
		"HR Manager",
		"IT Manager",
		"CEO",
		"Controller",
		"Sales Manager",
		"Support Manager",
		"Shipping Manager",
	]; */

  constructor(private cdr: ChangeDetectorRef) {
    // this.employee = this.employee;
    //	this.positions = this.positions;
    //	this.rules = { X: /[02-9]/ };
  }

  ngAfterViewInit() {
    this.myform.instance.validate();
    this.myform.instance.resetOption('editorType');
    this.frm.instance.resetOption('editorType');
  }

  ngAfterViewChecked() {
    this.customValidationCheck.emit();
  }

  checkUndefined(val) {
    return isNotUndefined(val);
  }

  stringify(val) {
    return JSON.stringify(val);
  }

  buttonOptions: any = {
    text: 'Register',
    type: 'success',
    useSubmitBehavior: true,
  };

  submit(event) {
    //console.log('form event', event);
    alert(1);
  }

  form_fieldDataChanged(e) {
    /*TODO - bug to select
    //e.preventDefault();
    // //console.log("mudou", e, this.dataForm);
     if (!!this.fields) {
     if(Object.prototype.hasOwnProperty.call(this.dataForm, 'type')) {
       const {type} = this.dataForm;
        let showIdSegSocCode = false;
       if(type==="Abono" || type==="Desconto") {
          showIdSegSocCode = true;  
       }
        for (const iterator of this.fields) {
        this.contentCheked =
         !!this.myform.instance.itemOption(
          iterator.dataField,
        );
        if(iterator.dataField ==="id_segsoc_code") {
          iterator.visible = true;
        this.myform.instance.itemOption(
          iterator.dataField,
          'visible',
          
          showIdSegSocCode,
        );
        
      }
      ////console.log(iterator.dataField);
        if(iterator.dataField ==="type") {
          //console.log("achou yeah", type);
        this.myform.instance.itemOption(
          iterator.dataField,
          'text',
          type
        );
        this.myform.instance.itemOption(
          iterator.dataField,
          'item',
          type
        );
           //console.log("oia", );
        }
    }
    //this.myform.itemsChange["type"].emit(type);
    //.getEditor('type').option(type);  
    
    
       //this.cdr.detectChanges();
       
     }
    	this.myform.instance.repaint();
     }
     */
  }

  onValueChanged() {
    //console.log('--------Value Change----------');
  }

  onFormSubmit = function (e) {
    //console.log('--------Submit----------');
    /* this.formEmit.emit({
			action,
			data: e,
			key: e.id,
		}); */
    // //console.log("frm submetido", e);
    // e.preventDefault();
  };

  checkCustom() {
    //console.log('--------	checkCustom ----------');
  }

  onContentReady(e) {
    if (!!this.fields && !this.contentCheked) {
      //  //console.log('--------	onContentReady ----------', this.fields, this.dataForm);
      let showIdSegSocCode = false;
      const { type } = this.dataForm;
      if (type === 'Abono' || type === 'Desconto') showIdSegSocCode = true;
      for (const iterator of this.fields) {
        this.contentCheked = !!this.myform.instance.itemOption(
          iterator.dataField
        );
        if (iterator.dataField === 'id_segsoc_code') {
          // && showIdSegSocCode) {
          iterator.visible = true;
        }
        this.myform.instance.itemOption(
          iterator.dataField,
          'caption',
          iterator.caption
        );
        this.myform.instance.itemOption(
          iterator.dataField,
          'visible',

          iterator.visible
        );
      }
    }
  }
}
